import { render, staticRenderFns } from "./universalSelect.vue?vue&type=template&id=966f987a&"
import script from "./universalSelect.vue?vue&type=script&lang=js&"
export * from "./universalSelect.vue?vue&type=script&lang=js&"
import style0 from "./universalSelect.vue?vue&type=style&index=0&id=966f987a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports